import React from "react";

import { clsx } from "clsx";

import { StyledContainer } from "@components/Styled/Container";

export const Container = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(
      props.className,
      "relative mx-auto flex flex-wrap md:max-w-2xl md:px-maxi xl:px-tera",
    )}
  />
);

export const Content = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "md:w-4/10 md:pr-0 2xl:pr-0 z-10 w-full px-midi md:mx-auto md:px-maxi md:pb-midi md:pt-micro 2xl:px-tera",
    )}
  />
);

export const Desktop = (props: any) => (
  <div {...props} className={clsx(props.className, "hidden md:block")} />
);

export const Mobile = (props: any) => (
  <div {...props} className={clsx(props.className, "block md:hidden")} />
);

export const Sticky = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "md:w-6/10 xl:w-5/10 w-full md:sticky md:top-[180px] md:self-start",
    )}
  />
);

export const Title = (props: any) => (
  <h1
    {...props}
    className={clsx(props.className, "font-display text-h3 leading-h1")}
  />
);

export const TitleWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "flex items-start justify-between xl:items-center",
    )}
  />
);
